export default __webpack_public_path__ + "static/media/Alert-dark.838bd127.svg";